import { generateCrosswordImage } from '@/api/crossword';
import { IndexDbService } from './indexDbService';

(function () {
    'ngInject';

    angular.module('app.shared.services').factory('CrosswordService', crosswordService);

    const indexDbService = new IndexDbService();

    function crosswordService(blockUI, CrosswordAPIService, $window, $mdDialog, $timeout, $rootScope) {
        const BLOCK_UI_MESSAGE = 'Generating your crossword 📝✨🎨';

        function getTargetObjects($scope) {
            const { bulkEdit, selectedObjectGroup, imageSelected } = $scope;
            return bulkEdit?.enabled ? selectedObjectGroup?._objects : imageSelected ? [imageSelected] : [];
        }

        function saveTestingValue(uuid, value) {
            if ($rootScope?.user?.AccessRoles?.Serialized?.split(',')?.includes('skip-save-testing-values')) {
                return;
            }

            indexDbService.findAndEditValue(uuid, value);
        }

        function applyGeneratedImage($scope, canvas, targetObjects, src) {
            //WTF, if I don't wrap the blockUI.stop() in a $scope.$apply it wont work :|
            const stopBlockUI = () => $scope.$apply(() => blockUI.stop());

            const img = new Image();
            img.onload = function () {
                for (const targetObject of targetObjects) {
                    targetObject.setElement(img);
                    targetObject.testingUrl = img.src;
                    saveTestingValue(targetObject.uuid, img.src);
                }
                canvas.renderAll();
                stopBlockUI();
            };
            img.onerror = function (e) {
                console.log(e);
                stopBlockUI();
            };
            img.src = src;
        }

        function handleGenerationError($scope, error) {
            $window.rumReportError(error);
            $timeout(() => $scope.$apply());
            blockUI.stop();

            $mdDialog.show(
                $mdDialog
                    .alert()
                    .parent(document.body)
                    .clickOutsideToClose(true)
                    .title('We received an error the from Crossword generator:')
                    .textContent(error.message)
                    .ok('OK!')
            );
        }

        /** Legacy flow: templates configured with CrosswordConfig keep using crossword.customily.com */
        function generateCrossword($scope, canvas, textTyped, chipImageUrls) {
            const targetObjects = getTargetObjects($scope);
            blockUI.start(BLOCK_UI_MESSAGE);

            CrosswordAPIService.generateCrossword(textTyped, chipImageUrls)
                .then((blob) => applyGeneratedImage($scope, canvas, targetObjects, URL.createObjectURL(blob)))
                .catch((error) => handleGenerationError($scope, error));
        }

        /** Settings flow: generated by the storefront service */
        function generateCrosswordFromSettings($scope, canvas, textTyped, settings, testStyleId) {
            const targetObjects = getTargetObjects($scope);
            const words = (textTyped || '').split(/[\s,]+/).filter(Boolean);
            blockUI.start(BLOCK_UI_MESSAGE);

            // Alternating renders every style, otherwise only the one picked for the test
            const selected = settings.styles.find((style) => style.id === testStyleId);
            const styles = settings.alternateStyles ? settings.styles : [selected || settings.styles[0]];

            generateCrosswordImage(words, { ...settings, styles })
                .then(({ base64 }) => applyGeneratedImage($scope, canvas, targetObjects, `data:image/png;base64,${base64}`))
                .catch((error) => handleGenerationError($scope, error));
        }

        function getAllTextures() {
            return CrosswordAPIService.getTextures().catch((e) => {
                console.error(e);
                return [];
            });
        }

        function changeTexture(texturePath, crosswordSelected) {
            if (texturePath == 'null') {
                crosswordSelected.set('CrosswordConfig', null);
                return;
            }

            crosswordSelected.set('CrosswordConfig', {
                path: texturePath
            });
        }

        function getCurrentTexture(crosswordSelected) {
            return crosswordSelected?.CrosswordConfig?.path || null;
        }

        return {
            generateCrossword,
            generateCrosswordFromSettings,
            getAllTextures,
            changeTexture,
            getCurrentTexture
        };
    }
})();
